<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Actividad Log</h4>
            <div class="small text-muted">Genera un log de todos los movimientos generados que modifican datos</div>
          </b-col>          
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>          
            <b-col sm="12" md="6" lg="4">               
              <Widget :configWidget="configWidget" reference="list_last_login" :hasAccess="configWidget.elements.listLastLogin" />
            </b-col>       
            <b-col sm="12" md="12" lg="8">               
              <Widget :configWidget="configWidget" reference="bar_activity_months" :hasAccess="configWidget.elements.barActivityMonths" />
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3">
        
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openViewer()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Visor</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Visualiza toda la actividad realizada en el sistema
              </p>
            </b-list-group-item>
          </b-list-group>                     
   
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.ACTIVIDAD_LOG,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.ACTIVIDAD_LOG,
          profile_id: Profiles.PERSONAL,
          elements: {             
            listLastLogin: true,
            barActivityMonths: true,
          }
        },
        primaryColor: '',             
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.listLastLogin = Helper.hasAccessWidget(this.configWidget, 'list_last_login')            
      this.configWidget.elements.barActivityMonths = Helper.hasAccessWidget(this.configWidget, 'bar_activity_months')            
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    },    
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openViewer() {
        this.$router.push({ name: 'ActivityLogStaffViewer' })
      },        
    }    
   
  }
</script>

<style>

</style>
